import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-prevnexticon',
  templateUrl: './prevnexticon.component.html',
  styleUrls: ['./prevnexticon.component.css']
})
export class PrevnexticonComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() type: string;
  @Input() description: string;
  @Input() class: string;
  @Input() data: string;
  @Output() callFunction = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.group = new FormGroup({
      firstName: new FormControl()
    });
  }
  onClick(event) {
    this.callFunction.emit('I am button');
  }
}
